import { getFlattenContentPages } from "@/utils"
import { type IDBContentPage } from "@netfront/ekardo-content-library";

export const isMenuItemDisabled = (id: number, currentPageId: number, contentPages: IDBContentPage[]) => {
  const menuItemPage = getFlattenContentPages(contentPages).find(({ id: pageId }) => pageId === id);
  const currentPage = getFlattenContentPages(contentPages).find(({ id: pageId }) => pageId === currentPageId);

  return menuItemPage === currentPage || menuItemPage?.isCompleted
    ? false
    : getFlattenContentPages(contentPages).findIndex(({ id: pageId }) => pageId === id) > getFlattenContentPages(contentPages).findIndex(({ id }) => id === currentPageId)
};